import PageLayout from "../components/pageLayout";
import {ResetPasswordForm} from "../components/Form/ResetPasswordForm";
import { useParams, useHistory } from 'react-router-dom';

export default function ResetPasswordPage() {
    const params = useParams();
    const history = useHistory();

    /*
        - Pass a navigation function instead of the hook. This is needed to redirect the page to the login page after resetting the password.
        - The token is passed as a parameter in the url. (web/src/App.js and server/routes/users.js)
    */
    const navigateToLogin = () => history.push('/login');

    return (
        <PageLayout children={<ResetPasswordForm token={params.token} navigateToLogin={navigateToLogin}/>}>
        </PageLayout>
    )
}